import type {
  Plan,
  SubscriptionCycle,
  SubscriptionStatus,
  Platform,
} from "./enums";

export interface UserCredits {
  monthly: number;
  purchased: number;
}

export interface AdminSubscriptionItem {
  subscriptionId: string;
  userId: string;
  userEmail: string;
  userName: string;
  userCredits: UserCredits;
  plan: Plan;
  price: number;
  subscriptionCycle: SubscriptionCycle;
  status: SubscriptionStatus;
  platform?: Platform;
  nextPaymentDate?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AdminSubscriptionFilters {
  searchQuery?: string;
  plan?: Plan;
  status?: SubscriptionStatus;
  platform?: Platform;
  platformIsNull?: boolean;
  subscriptionCycle?: SubscriptionCycle;
}

export interface AdminSubscriptionStats {
  monthly: number;
  yearly: number;
  total: number;
}

export interface SubscriptionAnalyticsBreakdownItem {
  plan: Plan;
  subscriptionCycle: SubscriptionCycle;
  platform: Platform | null;
  count: number;
}

export interface AdminSubscriptionAnalytics {
  breakdown: SubscriptionAnalyticsBreakdownItem[];
  mrrKrw: number;
  arrKrw: number;
  pendingCancellationCount: number;
}

export interface SubscriptionTrendPoint {
  date: string;
  breakdown: SubscriptionAnalyticsBreakdownItem[];
}

export enum AdminRefundMode {
  TOSS_REFUND = "TOSS_REFUND",
  STRIPE_REFUND = "STRIPE_REFUND",
  ANDROID_REFUND = "ANDROID_REFUND",
  FREE_ONLY = "FREE_ONLY",
}

export interface AdminRefundInput {
  userId: string;
  mode: AdminRefundMode;
  amount?: number;
  reason: string;
}

export interface AdminRefundablePayment {
  refundable: boolean;
  refundMode?: AdminRefundMode;
  requiresAmount: boolean;
  freeOnlyAvailable: boolean;
  currency?: string;
  platform?: Platform;
  paymentKey?: string;
  totalAmount?: number;
  balanceAmount?: number;
  method?: string;
  status?: string;
  approvedAt?: string;
  reason?: string;
}

export interface AdminUpgradeInput {
  userId: string;
  plan: Plan;
  subscriptionCycle?: SubscriptionCycle;
  durationDays?: number;
  endDate?: string;
  reason?: string;
}

export interface AdminGrantCreditsInput {
  userId: string;
  amount: number;
  reason?: string;
}

export interface AdminExtendBilledSubscriptionInput {
  userId: string;
  months: number;
  reason?: string;
}
